import React from "react"

const BowRight = ({
  colors = [
    "#939393",
    "#EED793",
    "#B5AC95",
    "#925C25",
    "#AA8B2F",
    "#FFCE06",
    "#42140B"
  ]
}) => {
  return (
    <g id="BowRight">
      <path
        opacity="0.25"
        d="M53.5175896,119.4079208l-0.1897659-0.0948792l-0.2846413-0.5692902 c0,0.0948792,0,0.0948792,0,0.1897583c0,0,0-0.0948792-0.1897659-0.3795242 c-0.7590523-0.5692902-5.2184906-2.0873947-7.5905304-2.8464508l-0.6641731-0.1897583 c-9.962574-3.6055069-13.5680752-17.2684555-14.7066555-21.8227768c-0.2846432-0.948822-0.5692902-2.0873947-0.8539333-2.94133 c-0.094883-0.0948792-0.189764-0.0948792-0.2846451-0.1897659h-0.0948811l-0.8539352-0.7590561l0.2846451-1.1385727 l-2.6566849-5.9775467l-1.0436974-0.5692902l0.0948811-1.0436935l0.094883-0.0948792c0-0.0948868,0-0.1897659,0.0948811-0.2846527 c-0.3795261-0.7590561-1.0436974-1.7078705-1.6129875-2.5617981c-2.5618057-3.8901443-10.2472181-15.8452377-6.1673069-25.6180458 l0.2846451-0.6641731c0.9488144-2.1822777,2.94133-6.641716,3.0362129-7.5905304 c-0.094883-0.2846451-0.094883-0.379528-0.094883-0.379528s0,0.0948792,0.094883,0.0948792l-0.2846451-0.5692902v-0.1897659 c0.189764-0.9488144,0.6641731-1.6129875,1.3283424-1.6129875l0.8539352,0.4744072l0.2846432,0.379528l0.189764,0.4744072 c0,0.094883,0,0.094883,0,0.2846451l32.734169,74.2923279c0.0948792,0.0948868,0.0948792,0.0948868,0.1897621,0.1897659 l0.2846451,0.4744034l0.0948792,0.474411l-0.2846451,0.8539352c-0.1897621,0.1897583-0.5692863,0.3795319-0.8539352,0.3795319 C54.1817627,119.7874527,53.7073517,119.5028,53.5175896,119.4079208z M21.9220028,46.8234634 c-0.5692902,1.9925117-1.5181065,4.6492004-2.3720417,7.3058853c-2.5618038,7.2110062,3.0362129,15.9401169,6.451952,21.1586075 l0.4744072,0.7590561c0.5692902,0.8539352,1.0436993,1.5181046,1.3283424,2.1822815l0.8539352,0.0948792l0.4744072,0.9488144 v0.1897659H29.22789l0.0948811,0.1897583l-0.189764,0.474411l3.1310959,7.2109985l0.4744072,0.2846527l0.2846451,0.4744034 v0.0948792l0.0948792,0.0948792l0.379528,1.0437012l-0.4744072,0.6641769 c0.1897659,0.6641693,0.4744072,1.5181046,0.6641731,2.4669189l0.2846451,0.9488144 c1.6129875,5.9775467,4.1747932,16.0350037,11.2909164,18.9763336c2.5618057,1.1385727,5.1236076,2.1822815,7.021244,3.1310959 L21.9220028,46.8234634z"
      />
      <polygon
        fill={colors[0]}
        points="54.5612907,118.6488724 54.6561699,118.5539856 21.3527145,42.9333153 21.2578316,43.0281982"
      />
      <g fill={colors[1]}>
        <polygon points="26.7609673,83.4477768 28.7534809,82.1194382 28.9432449,82.4040833 29.3227711,83.2580185 27.1404934,84.491478" />
        <polygon points="26.1916771,82.2143173 28.3739548,80.9808578 28.7534809,81.9296722 26.5712051,83.2580185" />
        <polygon points="29.6074162,87.1481628 30.7459965,86.6737518 31.2204037,87.4328079 30.4613495,87.8123398" />
        <polygon points="28.9432449,88.5713882 28.5637169,87.6225739 29.5125332,87.243042 30.3664703,87.9072189" />
        <polygon points="27.6149006,85.5351791 29.7971802,84.3965912 30.2715874,85.4403 28.0893097,86.5788727" />
        <polygon points="28.3739548,87.1481628 28.1841908,86.768631 30.3664703,85.5351791 30.5562325,86.1044693 30.7459965,86.4839935 28.4688377,87.4328079" />
        <polygon points="29.22789,89.1406784 29.038126,88.6662674 31.2204037,87.6225739 31.6948128,88.7611542" />
      </g>
      <g fill={colors[2]}>
        <polygon points="27.5200214,85.3454132 27.2353745,84.5863571 28.7534809,83.827301 29.417654,84.491478" />
        <polygon points="29.7971802,84.301712 29.6074162,84.3965912 28.8483639,83.7324219 29.417654,83.4477768" />
      </g>
      <g fill={colors[2]}>
        <polygon points="26.096796,82.0245514 25.812149,81.3603821 26.1916771,81.075737 26.7609673,81.6450348" />
        <polygon points="28.1841908,80.7910919 26.8558483,81.6450348 26.2865582,80.9808578 27.8046646,79.8422775" />
      </g>
      <path
        fill={colors[3]}
        d="M21.4475937,44.4514236c-0.189764,1.7078667-1.5181065,5.5031319-2.8464489,9.2983971 c-2.8464499,8.0649414,3.6055012,17.4582253,7.0212402,22.771595c0.8539352,1.2334595,1.4232254,2.2771606,1.8976345,3.0362091 l-1.6129894,1.7078705c-0.189764-0.6641693-1.1385803-2.0873947-2.0873966-3.6055069 c-3.6055012-5.5031357-9.677928-16.129879-6.0724258-24.7641068c1.3283424-3.1310921,3.510622-7.9700584,3.320858-8.7291107 c-0.1897602-0.7590446-0.2846413-0.7590446-0.2846413-0.7590446s0.0948811-0.7590523,0.4744072-0.7590523l0.2846451,0.379528 C21.5424767,43.0281982,21.5424767,43.4077263,21.4475937,44.4514236z"
      />
      <ellipse
        transform="rotate(-45.438 26.65 80.213)"
        fill={colors[4]}
        cx="26.65"
        cy="80.213"
        rx="1.613"
        ry="0.664"
      />
      <polygon
        fill={colors[5]}
        points="25.4326229,81.2655029 27.7097836,78.798584 28.1841908,79.7473984 25.2428589,82.3091965"
      />
      <polygon
        fill={colors[6]}
        points="29.22789,89.2355652 28.3739548,87.243042 26.7609673,83.4477768 25.812149,81.4552612 27.8046646,79.9371567 28.9432449,82.4989624 30.6511135,86.1993484 31.7896938,88.7611542"
      />
      <polygon
        fill={colors[5]}
        points="29.133007,89.7099686 32.548748,89.6150818 32.16922,88.6662674 28.2790737,89.0457916"
      />
      <path
        fill={colors[3]}
        d="M53.5175896,117.4154053c-1.4232254-0.9488144-5.0287285-2.5617981-8.8239937-4.1747894 c-7.8751755-3.3208618-10.4369812-14.4220047-12.0499687-20.589325 c-0.3795242-1.4232254-0.6641712-2.5617981-0.9488163-3.4157333h-2.2771587 c0.2846432,0.5692825,0.7590523,2.2771606,1.2334595,3.9850235c1.7078705,6.3570709,5.3133736,18.0275116,14.1373672,21.1585999 c3.225975,1.1385803,8.2547035,2.7515717,8.7291107,3.415741s0.379528,0.6641693,0.379528,0.6641693 s0.6641731,0.474411,0.8539352,0.1897583l-0.0948792-0.4744034 C54.7510529,118.3642273,54.466404,118.0795746,53.5175896,117.4154053z"
      />
      <ellipse
        transform="rotate(-2.125 30.746 89.424)"
        fill={colors[4]}
        cx="30.746"
        cy="89.423"
        rx="1.613"
        ry="0.664"
      />
      <polygon
        fill={colors[4]}
        points="29.133007,88.9509125 32.16922,88.6662674 31.8845749,88.0969772 28.9432449,88.4765091"
      />
      <polygon
        fill={colors[4]}
        points="26.0019131,81.9296722 28.2790737,79.9371567 28.1841908,79.7473984 26.0019131,81.7399139"
      />
    </g>
  )
}

export default BowRight
